// import "./instrument";
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './index.css';

import App from './App';
import { B4aLoaderStandalone } from './components/B4aLoader';

const CreateAppFlow2 = lazy(() => import(/* webpackPrefetch: true */ "./containers/CreateAppFlow2"));

async function bootstrap() {
  if (typeof globalThis.fetch !== 'function') {
    await import('cross-fetch/polyfill');
  }

  import('./instrument').then(() => {
    console.log('Instrumentation initialized');
  });

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<Navigate replace to="/apps/new" />} />
            <Route
              path="apps/new"
              element={
                <Suspense fallback={
                  <div className="flex justify-center items-center h-full bg-dark">
                    <B4aLoaderStandalone />
                  </div>
                }>
                  <CreateAppFlow2 />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

void bootstrap();

// Defer reportWebVitals to avoid blocking initial load
import('./reportWebVitals').then(({ default: reportWebVitals }) => {
  reportWebVitals(console.log);
});